import React from "react";
import { graphql } from "gatsby";
import { generateArticleSchema } from "@utils/lcArticleSchema";
import { getProcessedFaqs } from "@components/shared/faqs";
import { generateFaqSchema } from "@utils/schemaGenerators";
import { SeoMetadata } from "@components/shared/seoMetadata";
import LcArticleLayout from "@components/learningCenter/lcArticleLayout";

export default function LcArticle({ data, pageContext }) {
  const { contentfulLcArticle: article } = data;

  return (
    <LcArticleLayout
      title={article.title}
      body={article.body}
      metaDescription={article?.metaDescription?.metaDescription}
      metaTitle={article?.metaTitle}
      {...pageContext}
    />
  );
}

export function Head({ data }) {
  const { contentfulLcArticle: article } = data;
  const references = data?.contentfulLcArticle?.body?.references || [];
  const faqSection = references.find(
    (ref) => ref.__typename === "ContentfulGenericList" && ref.listItems?.[0]?.__typename === "ContentfulListItemFaq"
  );
  const faqs = getProcessedFaqs(faqSection?.listItems || []);
  const articleSchema = generateArticleSchema(article);
  const isEarlyAccessResources = article.lc_category?.[0]?.slug === "early-access-resources";
  return (
    <>
      <SeoMetadata
        title={article?.metaTitle || article?.title}
        description={article?.metaDescription?.metaDescription}
        noIndex={isEarlyAccessResources}
      />
      <script
        type="application/ld+json"
        id="article-schema-lc"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      {faqs.length > 0 && (
        <script
          type="application/ld+json"
          id="faq-schema-lc"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(generateFaqSchema(faqs)) }}
        />
      )}
    </>
  );
}

export const query = graphql`
  query ($articleSlug: String!) {
    contentfulLcArticle(slug: { eq: $articleSlug }) {
      title
      slug
      metaDescription {
        metaDescription
      }
      metaTitle
      lc_category {
        slug
      }
      ...sharedArticleBody
    }
  }
`;
